import { render, staticRenderFns } from "./ClinicOnboardingPhotos.vue?vue&type=template&id=bf945ba0&scoped=true&"
import script from "./ClinicOnboardingPhotos.vue?vue&type=script&lang=js&"
export * from "./ClinicOnboardingPhotos.vue?vue&type=script&lang=js&"
import style0 from "./ClinicOnboardingPhotos.vue?vue&type=style&index=0&id=bf945ba0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf945ba0",
  null
  
)

export default component.exports